import React 				from 'react';
import PropTypes 			from 'prop-types';
import BLComponent			from '../core/_BLComponent.jsx';

export default class Pagination extends BLComponent 
{
	constructor( props ) 
	{
		super( props );

		const 	isOnDemand		= this.props.data && this.props.data.totalItemCnt && this.props.data.totalItemCnt > 0 ? true : false;
		const	totalItemCnt	= isOnDemand ? this.props.data.totalItemCnt : this.props.children.length;
		const	maxPages		= Math.max( Math.ceil( totalItemCnt / this.props.data.postsPerPage ), 1 );
		const currentPage = blapp.util.getUrlVar('page') ? parseInt(blapp.util.getUrlVar('page')) : this.props.data.currentPage || 1;

		this.state = 
			{
				isOnDemand:			isOnDemand
			,	currentPage:		currentPage
			,	tempPageJump: 		''
			,	totalItemCnt:		totalItemCnt
			,	maxPages:			maxPages
			,	dummy:				0
			};

		this.paginationBtns	= [];
	}

	static getDerivedStateFromProps( nextProps, prevState ) 
	{
		let	newState	= prevState;

		if ( nextProps.data )
		{
			newState				= _.cloneDeep( prevState );
			newState.isOnDemand		= nextProps.data.totalItemCnt && nextProps.data.totalItemCnt > 0 ? true : false;
			newState.totalItemCnt	= newState.isOnDemand ? nextProps.data.totalItemCnt : nextProps.children.length;
			newState.maxPages		= Math.max( Math.ceil( newState.totalItemCnt / nextProps.data.postsPerPage ), 1 );
			newState.currentPage	= Math.min( blapp.util.getUrlVar('page') ?  parseInt(blapp.util.getUrlVar('page')) : nextProps.data.currentPage ? nextProps.data.currentPage : newState.currentPage, newState.maxPages );
		}

		return newState;
	}	

	componentDidMount() 
	{
		this.buildAvailableLinks( this.props.data.postsPerPage, this.state.currentPage, this.state.maxPages, this.state.totalItemCnt );
		this.setState( { dummy: this.state.dummy + 1 } );

		window.addEventListener(
			'resize'
		,	() => 
			{ 
				this.buildAvailableLinks( this.props.data.postsPerPage, this.state.currentPage, this.state.maxPages, this.state.totalItemCnt );
				this.setState( { dummy: this.state.dummy + 1 } );
			}
		);
	}

	shouldComponentUpdate( nextProps, nextState )
	{ 
		const {shouldScrollTop = true} = this.props;
		if ( nextProps.data.postsPerPage != this.props.data.postsPerPage
			|| nextState.currentPage != this.state.currentPage
			|| nextState.totalItemCnt != this.state.totalItemCnt )
		{
			this.buildAvailableLinks( nextProps.data.postsPerPage, nextState.currentPage, nextState.maxPages, nextState.totalItemCnt );
			
			if(shouldScrollTop) {
				window.scrollTo(0, 0);
			}
		}

		return true;
	}	

	render() 
	{
		const 	{classes = '', containerClasses = ''} = this.props;
		const 	{postsPerPage, currentPage = 1} = this.props.data;

		return (
			<React.Fragment>
				{this.renderPagedContent()}
				{
					postsPerPage < this.state.totalItemCnt && postsPerPage != -1 ?
					<article className={"pagination " + classes}>
						{this.renderPagination()}
						<label className="pagination__jump">
							Jump to:
							<input type="number" className="pagination__jump-input text-input text-input--sm l-margin-x--sm" onChange={(e) => this.setState({tempPageJump: e.target.value})} value={this.state.tempPageJump} onKeyPress={(event) => this.jumpTo(event)}/>
							<strong>/ {this.state.maxPages}</strong>
						</label>
					</article>
					: null
				}
			</React.Fragment>
		);
	}

	renderPagination() 
	{
		const	{postsPerPage}	= this.props.data;
		const	{currentPage}	= this.state;

		const links =	this.paginationBtns.map(
							(btn, key) => 
							{
								switch(btn.type) 
								{
								case 'prev':
									return (
										<li key={key + '' + btn.pageLink} className="pagination__btn">
											<a href={currentPage != 1 ? this.returnPageURL(currentPage - 1) : ''} onClick={currentPage != 1 ? (e) => this.changePage(e, currentPage - 1) : (e) => e.preventDefault()} className={`pagination__btn-item pagination__btn-item--prev ${currentPage == 1 ? 'pagination__btn-item--disabled' : ''}`}>
												<i className="fas fa-long-arrow-left"/>
											</a>
										</li>
									);

								case 'next':
									return (
										<li key={key + '' + btn.pageLink} className="pagination__btn">
											<a href={currentPage != this.state.maxPages ? this.returnPageURL(currentPage + 1) : ''} onClick={currentPage != this.state.maxPages ? (e) => this.changePage(e, currentPage + 1) : (e) => e.preventDefault()} className={`pagination__btn-item pagination__btn-item--next ${currentPage == this.state.maxPages ? 'pagination__btn-item--disabled' : ''}`}>
												<i className="fas fa-long-arrow-right"/>
											</a>
										</li>
									);

								case 'concat':
									return (
										<li key={key + '' + btn.pageLink} className="pagination__btn">
											<a href={this.returnPageURL(btn.pageLink)} onClick={(e) => this.changePage(e, btn.pageLink)} className={`pagination__btn-item pagination__btn-item--concat`}>
												...
											</a>
										</li>
									);

								case 'page':
									return (
										<li key={key + '' + btn.pageLink} className="pagination__btn">
											<a href={this.returnPageURL(btn.pageLink)} onClick={(e) => this.changePage(e, btn.pageLink)} className={`pagination__btn-item pagination__btn-item--page ${currentPage == btn.pageLink ? 'pagination__btn-item--active' : ''}`}>
												{btn.pageLink}
											</a>
										</li>
									);
								}
							}
						);

		return (
			<ul className="pagination__main">
				{links}
			</ul>
		);
	}

	buildAvailableLinks( postsPerPage, currentPage, maxPages, totalItemCnt ) 
	{
		let links 						= [];

		try
		{
			if ( postsPerPage < totalItemCnt ) 
			{
				if ( _.isEmpty( document.querySelectorAll( '.pagination' ) ) )
				{	// Try again after the render
					setTimeout( 
						() => 
						{ 
							this.buildAvailableLinks( postsPerPage, currentPage, maxPages, totalItemCnt ); 
							this.setState( { dummy: this.state.dummy + 1 } );
						}
					,	100
					);
					return;
				}

				const buttonWidth 			= 36;
				const arrowWidth 			= 24;
				const padding 				= 24;
				const containerWidth 		= document.querySelectorAll('.pagination')[0].offsetWidth;
				const jumpWidth 			= window.innerWidth <= 840 ? padding : document.querySelectorAll('.pagination__jump')[0].offsetWidth;
				const availableButtons 		= Math.round((containerWidth - jumpWidth - (arrowWidth * 2)) / buttonWidth);

				if (maxPages > availableButtons ) 
				{
					const	availableGroups		= (maxPages - (availableButtons - 2)) / (availableButtons - 4) + 1;
					const	currentGroup 		= currentPage <= availableButtons - 2 ? 0 : Math.floor(((currentPage - 1) - (availableButtons - 2)) / (availableButtons - 4)) + 1;
					const	lastPageCount 		= (maxPages - (availableButtons - 2)) % (availableButtons - 4);
					const	mandatoryButtonCount= currentGroup == 0 ? 2 : 4;
					const	buttonSlots 		= availableButtons - mandatoryButtonCount;
					let		buttonsPerGroup 	= 0;

					if (lastPageCount <= 2 && currentGroup == Math.floor(availableGroups) - 1 ) 
					{
						buttonsPerGroup = buttonSlots + lastPageCount;
					}
					else if (lastPageCount <= 2 && currentGroup == Math.floor(availableGroups) ) 
					{
						buttonsPerGroup = buttonSlots + lastPageCount;
					}
					else if ( currentGroup == Math.floor(availableGroups) ) 
					{
						buttonsPerGroup = lastPageCount;
					}
					else
					{
						buttonsPerGroup = buttonSlots;
					}

					links.push({type: 'prev'});

					if (currentGroup > 0 ) 
					{
						const prevGroupLink = currentGroup == 1 ? availableButtons - 2 : (availableButtons - 2) + ((currentGroup - 1) * buttonSlots);

						links.push({type: 'page', pageLink: 1});
						links.push({type: 'concat', pageLink: prevGroupLink});
					}

					for ( let i = 1; i <= buttonsPerGroup; ++i ) 
					{
						let prevMax = 0;

						if ( currentGroup == 0 ) 
						{
							prevMax = 0;
						}
						else if ( currentGroup == 1 ) 
						{
							prevMax = buttonSlots + 2;
						}
						else if ( currentGroup == Math.floor(availableGroups) && lastPageCount <= 2 ) 
						{
							prevMax = (currentGroup - 1) * buttonSlots + 2;
						}
						else
						{
							prevMax = currentGroup * buttonSlots + 2;
						}

						links.push({type: 'page', pageLink: prevMax + i});
					}


					if ( currentGroup != Math.floor(availableGroups) ) 
					{
						if ( lastPageCount <= 2 && currentGroup == (Math.floor(availableGroups) - 1) ) 
						{
							
						}
						else
						{
							const nextGroupLink = currentGroup == 0 ? buttonSlots + 1 : (availableButtons - 2) + (currentGroup * buttonSlots) + 1;

							links.push({type: 'concat', pageLink: nextGroupLink});
							links.push({type: 'page', pageLink: maxPages});
						}
					}

					links.push({type: 'next'});
				}
				else
				{
					links.push({type: 'prev'});

					for ( let i = 1; i <= maxPages; ++i ) 
					{
						links.push({type: 'page', pageLink: i});
					} 

					links.push({type: 'next'});
				}
			}

			this.paginationBtns	= links;
		}
		catch ( e )
		{
			console.log( e );
		}
	}

	changePage(e, page) 
	{
		if ( e )
			e.preventDefault();

		const maxPages = this.state.maxPages;

		if ( page < 0 || page > maxPages ) 
		{
			return;
		}

		if ( this.props.data.changePageCallback ) 
		{
			this.props.data.changePageCallback( page );
		}

		this.setState( {currentPage: page, tempPageJump: '' } );

		const newURL = blapp.util.addParamToUrl('page', page, window.location);
		history.pushState('', '', newURL);
	}

	renderPagedContent() 
	{
		const	start		= this.state.isOnDemand ? 0 : (this.state.currentPage - 1) * this.props.data.postsPerPage;
		const	end 		= this.props.data.postsPerPage == -1 ? this.props.data.totalItemCnt : this.props.data.postsPerPage;

		if ( this.props.containerClasses ) 
		{
			return <div className={this.props.containerClasses}>{[...this.props.children].splice(start, end)}</div>
		}
		else
		{
			return [...this.props.children].splice(start, end);
		}
	}

	jumpTo( event ) 
	{
		if ( event.key === 'Enter' ) 
		{
			this.changePage( null, parseInt( this.state.tempPageJump ) );
		}
	}

	returnPageURL( page ) 
	{
		const	bindQS	= this.props.bindQS || "page";

		return blapp.url2.getCurrentUrlWithMergedQS( bindQS + "=" + page );
	}
}

Pagination.propTypes = 
	{
		classes:	PropTypes.string
	,	data: 		PropTypes.shape(
						{
							postsPerPage:			PropTypes.Number
						,	currentPage:			PropTypes.Number
						,	changePageCallback:		PropTypes.Function
						,	totalItemCnt:			PropTypes.Number		// If this value is positive number, it works as on-demand.
						}
					).isRequired
	,	bindQS:		PropTypes.string
	
	}